import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBtInboundArrow = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M5.92068 14.64L3.60829 14.9186L3.8868 12.607L4.40668 13.1269L4.74759 13.4678L5.10068 13.1396C5.80136 12.4881 6.53187 11.7236 7.22253 10.9899C7.34412 10.8608 7.46434 10.7327 7.58295 10.6064C8.1433 10.0095 8.66754 9.45106 9.12943 8.9965L9.12944 8.99651L9.13216 8.99379L14.5369 3.5924L14.8154 3.86968C13.7875 4.85647 12.7061 5.99262 11.7154 7.03345C11.1621 7.61474 10.6371 8.1663 10.1656 8.6455L5.39978 13.413L5.04606 13.7669L5.40014 14.1204L5.92068 14.64Z",
		fill: "black",
		stroke: "black"
	})
});
export default SvgBtInboundArrow;
